/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import ActionModel from 'cio/models/action';
import { Task } from 'ember-concurrency';
import { VWB_INITIATE_SINGLE_DELETE_FROM_KEYBOARD_SHORTCUT } from 'cio/services/event-bus';

interface DelayDeleteButtonArgs {
  actionAbstract: {
    action: ActionModel;
    [key: string]: any;
  };
  deleteTask: Task<unknown, []>;
  isSaving: boolean;
  onDeleteStarted: () => unknown;
  hasReadOnlyPermission: boolean;
}

export default class DelayDeleteButton extends Component<DelayDeleteButtonArgs> {
  VWB_INITIATE_SINGLE_DELETE_FROM_KEYBOARD_SHORTCUT = VWB_INITIATE_SINGLE_DELETE_FROM_KEYBOARD_SHORTCUT;
}
